/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from 'react-bootstrap-v5'
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

type Props = {
    className: string,
    parentToChild?: any[],
    username: string,
    codeBookHost?: string,
    allowParam?: boolean
}

const TablesCodeBookBba: React.FC<Props> = ({ parentToChild, className, username, codeBookHost, allowParam }) => {
    let i = 0;
    const intl = useIntl();
    const history = useHistory();
    function showCodeBookItemToEdit(longNameCodeBookItem: string, shortNameCodeBookItem: string, addressItem: string, id: number) {

        history.push({ pathname: '/editCodeBookBba', state: { longNameCodeBookParam: longNameCodeBookItem.toString(), shortNameCodeBookParam: shortNameCodeBookItem.toString(), addressParam: addressItem.toString(), codeBookHostparam: codeBookHost, idParam: id, allowParam: allowParam } })

    }





    return (
        <div className={`card ${className}`} style={{ width: "100%", position: "relative", backgroundColor: "InfoBackground", alignSelf: "center" }}>



            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='text-dark fw-bolder text-hover-primary fs-6'>{intl.formatMessage({ id: 'CODEBOOK.RESULTS' })}</span>
                </h3>
            </div>
            <div className='card-body py-3'>

                <div className='table-responsive'>

                    <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>

                        <thead>
                            <tr className='fw-bolder text-dark'>
                                <th className="text-left">RB</th>
                                <th className="text-left">Duži naziv</th>
                                <th className="text-left">Kraći naziv</th>
                                <th className="text-left">Adresa</th>
                                <th className="text-left">Korisnik koji je uradio poslednju izmjenu</th>
                                <th className="text-left">Datum zadnje promjene</th>


                            </tr>
                        </thead>

                        <tbody>

                            {parentToChild!.map(o => <tr key={o.id}>
                                <td width="2%">
                                    <span title="Redni broj" >
                                        {i = i + 1}
                                    </span>
                                </td>
                                <td width="11%">
                                    <span title="Duži naziv šifarnik" >
                                        {o.longNameCodeBook ? o.longNameCodeBook : ''}
                                    </span>
                                </td>
                                <td width="7%">
                                    <span title="Kraći naziv šifarnik" >
                                        {o.shortNameCodeBook ? o.shortNameCodeBook : ''}
                                    </span>
                                </td>
                                <td width="7%">
                                    <span title="Adresa" >
                                        {o.address ? o.address : ''}
                                    </span>
                                </td>
                                <td width="7%">
                                    <span title="Korisnik" >
                                        {o.username ? o.username : ''}
                                    </span>
                                </td>
                                <td width="7%">
                                    <span title="Datum zadnje promjene" >
                                        {o.lastDateModified ? (o.lastDateModified).substring(8, 10) + '.' + (o.lastDateModified).substring(5, 7) + '.' + (o.lastDateModified).substring(0, 4) + '. ' + (o.lastDateModified).substring(11, 13) + ':' + (o.lastDateModified).substring(14, 16) + ':' + (o.lastDateModified).substring(17, 19) : ''}
                                    </span>
                                </td>
                                <td width="10%">
                                    <span title="Kliknite mišem ovo dugme da uredite redak">
                                        <Button size="lg" style={{ width: "100%" }} onClick={() => {
                                            //exportStatusesDocx((parentToChild as AccountStatuses[]).filter(x => x.validFrom >= o.validFrom), IssuerDocumentId, '', selectedItem, footerArticle)
                                            showCodeBookItemToEdit(o.longNameCodeBook, o.shortNameCodeBook, o.address, o.id);

                                        }} >
                                            {'Uredite zapis'}
                                        </Button>
                                    </span>
                                </td>

                            </tr>)}
                        </tbody>

                    </table>
                    <ToastContainer position='bottom-center' />
                </div>

            </div>

        </div>
    )
}

export { TablesCodeBookBba }
